import request from "@/hooks/useRequest";

// 提交公司更新
export const submitKycIdExpiryUpdate = (params) => {
  return request("/web-wallet/api/v1/kyc/id-expiry/update", {
    body: params,
  });
};
